/* eslint-disable no-unused-vars */
/**
 *
 * 新埋点
 * 制定埋：
 * v-stat="'对象‘"
 * v-stat[show|click] = object || {
 *  object, event, ...other
 * }
 * 主动埋：
 * this.eventStat(object || {
 *  object, event, ...other
 * })
 *
 * object 默认会对「对象字段进行拼接」 pageName + object，需要避开这个规则可以选择：1. 直接v-stat={对象: 'xxxx'}  2. 路由配置: meta.disableStatPageName = true
 */

import 'mutationobserver-shim'
import Stat from '../lib/stat/Stat'
import { getPlatform } from '../tools/getPlatform'
import { GetQueryString } from '../tools/utils'
import { Base64 } from '../lib/base64'

const upLoadQuery = [
  'channelId',
  'channel_id',
  'cid',
  'channelFlag',
  'channel_flag',
  'source',
  'ref',
  'from',
  'site',
  'page',
  'sourceName',
  'enterid',
  '_source_page_',
  '_touch_name_'
]

const eventUpLoadQuery = ['channel_flag', 'cid']

const actionType = {
  click: '点击',
  show: '显示'
}

function isBase64(str) {
  if (str === '' || (typeof str === 'string' && str.trim() === '')) {
    return false
  }
  try {
    return Base64.encodeURI(Base64.decode(str)) == str
  } catch (err) {
    return false
  }
}

const handleQueryVal = val => {
  return isBase64(val) ? Base64.decode(val) : decodeURIComponent(val)
}

// 筛选掉有需要上传的东西
const filterQuery = (query, _upLoadQuery = upLoadQuery) => {
  const _query = {}
  for (let i = 0; i < _upLoadQuery.length; i++) {
    // 如果query有，优先取query
    if (query[_upLoadQuery[i]]) {
      _query[_upLoadQuery[i]] = handleQueryVal(query[_upLoadQuery[i]])
    } else {
      // spa项目?在#前面的情况
      const queryVal = GetQueryString(_upLoadQuery[i])
      if (queryVal) {
        _query[_upLoadQuery[i]] = handleQueryVal(queryVal)
      }
    }
  }

  if (_query._source_page_) {
    _query.page = _query._source_page_
    delete _query._source_page_
  }

  if (_query._touch_name_) {
    _query.site = _query._touch_name_
    delete _query._touch_name_
  }

  return _query
}

const mixin = {
  mounted() {
    // 除了node其他项目没有统一的加载结束的入口，所以不自动埋，需要手动调
    // 你也可以定义个fetchPromise 😊
    // 是页面组件
    // const isPageComponent =
    //   this.fetchPromise && typeof this.fetchPromise.then === 'function'
    // // console.log(`isPageComponentisPageComponent`, isPageComponent)
    // if (!this.$route) return
    // const { meta } = this.$route
    // if (!meta) return
    // // 路由定义有meta.bussiness
    // const businessInRouteMeta = meta && meta.business
    // if (isPageComponent && businessInRouteMeta) {
    //   this.fetchPromise.then(() => {
    //     this.pageStat()
    //   })
    // }
    // this._statPluginPageEntryTime = new Date().getTime()
  },
  // 统计离开，不准确
  // destroyed() {
  //   if (!this.$route) return
  //   const { meta } = this.$route
  //   if (!meta) return
  //   // 路由定义有meta.bussiness
  //   const businessInRouteMeta = meta && meta.business
  //   if (!businessInRouteMeta) return
  //   const ts = new Date().getTime() - this._statPluginPageEntryTime
  //   const durationSecond = (ts / 1000 / 60) | 0
  //   let text
  //   if (durationSecond < 30) {
  //     text = '小于30s'
  //   } else if (durationSecond < 60) {
  //     text = '30s-1min'
  //   } else if (durationSecond < 180) {
  //     text = '1min-3min'
  //   } else {
  //     text = '大于3min'
  //   }

  //   this.eventStat({
  //     object: '页面离开',
  //     浏览时间: text
  //   })
  // },
  computed: {
    pageStatProperties() {
      return {}
    },
    statMixinPlatform() {
      return this.$platform || this.platform || getPlatform()
    }
  },
  methods: {
    pageStat(properties = this.pageStatProperties) {
      console.log(properties)
      // const { meta, query } = this.$route
      // if (meta.disableStat) return
      // const { yixinliAPPVersion } = this.statMixinPlatform

      // const statData = {
      //   businessType: meta.business,
      //   category: meta.category || '',
      //   eventValue: meta.pageName,
      //   extraAttr: {
      //     href: window.location.href,
      //     UA: window.navigator.userAgent,
      //     title: meta.pageName || '',
      //     App版本: yixinliAPPVersion || '',
      //     ...filterQuery(query),
      //     ...properties
      //   }
      // }

      // this.$stat.visit(statData)
    },
    eventStat(value = '') {
      console.log(value)
      // const { query, meta } = this.$route

      // if (meta.disableStat) return

      // const {
      //   business,
      //   pageName,
      //   disableStatPageName,
      //   category
      // } = this.$route.meta
      // // 没定义就不继续了
      // if (!business) {
      //   console.warn('路由定义meta.business, pageName')
      // }

      // // 处理成对象
      // if (typeof value !== 'object') {
      //   value = {
      //     object: value
      //   }
      // }

      // //处理行为
      // value.event =
      //   actionType[value.event || (event && event.type)] ||
      //   value.event ||
      //   '点击'
      // const {
      //   object,
      //   event: _event,
      //   disableStatPageName: dsp,
      //   ...otherValue
      // } = value
      // const isDisablePageName = dsp !== undefined ? dsp : disableStatPageName

      // this.$stat.interact({
      //   businessType: business,
      //   category: category,
      //   eventValue:
      //     // && object.indexOf(pageName) !== 0
      //     pageName && !isDisablePageName ? `${pageName}-${object}` : object,
      //   pageTitle: pageName,
      //   extraAttr: {
      //     行为: _event,
      //     title: pageName,
      //     ...filterQuery(query, eventUpLoadQuery),
      //     ...otherValue
      //   }
      // })
    },

    // 获取跳转后所需埋点params， 仅支持点击后同步调用，不支持类似点击后请求再跳转
    // site 父级以上的data-site
    // page 页面名称
    getRunWithRouteQuerys() {
      const { meta } = this.$route
      if (!meta || !meta.pageName) return null

      let result = {
        _source_page_: Base64.encodeURI(meta.pageName)
      }

      if (event) {
        let target = event.target
        let site = ''

        try {
          let runTimes = 0 // 避免死循环
          while (target !== document.documentElement && runTimes < 100) {
            const _site = target.getAttribute('data-site')
            if (_site) {
              site = _site + (site ? '-' : '') + site // 支持嵌套
            }
            target = target.parentNode
            runTimes++
          }
        } catch (e) {
          console.log(e)
          site = ''
        }

        if (site) {
          result._touch_name_ = Base64.encodeURI(site)
        }
      }

      return result
    },

    // 弹窗也用页面访问埋点，分离pagestat方便后续变更
    visitStat(...args) {
      return this.pageStat(...args)
    }
  }
}

// 判断dom是不是隐藏的，针对v-show
const isDomHidden = el => el.style.display === 'none'

const handleShowStat = (el, statFn) => {
  // 延迟100ms是因为立即取dom style.display取不到
  setTimeout(() => {
    const isHidden = isDomHidden(el)
    // 如果隐藏就监听着v-show
    if (isHidden) {
      el.observer = new MutationObserver(mutations => {
        // 之前是隐藏的，这次监听到变化是显示的
        if (
          mutations[0].oldValue &&
          mutations[0].oldValue.indexOf('display: none') > -1 &&
          !mutations[0].target.style.display !== 'none'
        ) {
          statFn()
        }
      })
      const options = {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ['style']
      }
      el.observer.observe(el, options)
    } else {
      // 否则直接埋v-if
      statFn()
    }
  }, 100)
}

const getVstat = () => {
  const handleBindAndUpdate = (el, binding, vnode, handleShow = true) => {
    const { eventStat } = vnode.context
    let { modifiers } = binding
    // 如果没有修饰符，就当作是click
    if (Object.keys(modifiers).length === 0) {
      modifiers.click = true
    }

    const statData = () => {
      let value = binding.value
      // 处理value成对象
      if (typeof binding.value === 'string') {
        value = {
          object: binding.value
        }
      }
      return {
        被点击元素的文字: el.innerText.replace(/[ ]/g, ''),
        ...value
      }
    }
    Object.keys(modifiers).forEach(key => {
      if (key === 'show') {
        handleShow &&
          handleShowStat(el, () => {
            const _statData = statData()
            if (!_statData.event) {
              _statData.event = key
            }
            return eventStat(_statData)
          })
      } else {
        setTimeout(() => {
          const listener = () => eventStat(statData())
          const elAttrKey = `statListener-${key}`
          if (el[elAttrKey]) {
            el.removeEventListener(key, el[elAttrKey], true)
          }
          el[elAttrKey] = listener
          el.addEventListener(key, listener, true)
        })
      }
    })
  }
  return {
    bind(el, binding, vnode) {
      handleBindAndUpdate(el, binding, vnode)
    },
    componentUpdated(el, binding, vnode) {
      handleBindAndUpdate(el, binding, vnode, false)
    },
    unbind(el) {
      // 处理MutationObserver副作用
      if (el.observer) {
        el.observer.disconnect()
      }
    }
  }
}

export default {
  install(Vue, options) {
    let statOptions =
      options && options.statOptions ? options.statOptions : undefined
    const stat = new Stat(statOptions)
    Vue.prototype.$stat = stat
    if (!window.yxl) {
      window.yxl = {}
    }
    window.yxl.stat = stat
    Vue.mixin(mixin)
    Vue.directive('stat', getVstat(Vue))
    // 标记诸葛用户 for node-website
    if (options && options.store) {
      options.store.watch(
        () => options.store.state.userinfo,
        val => {
          try {
            if (val && val.id) {
              const {
                nickname,
                base: { gender }
              } = val

              const vals = {}
              // 清空误上传的
              for (let key in val) {
                vals[key] = ''
              }

              vals.nickname = nickname
              vals.gender = gender

              stat.identify(val.id, vals)
            }
          } catch (e) {
            console.log(e)
          }
        }
      )
    }
  }
}
